import { useEffect, useState } from "react";

import icon_btn_all from './images/all.png'
import icon_btn_all_active from './images/all (1).png'
import icon_tv_shows from '../../NavBar/images/clapperboard (1).png'
import icon_tv_shows_active from '../../NavBar/images/clapperboard.png'
import Icon_live_tv from '../../NavBar/images/television (1).png'
import Icon_live_tv_active from '../../NavBar/images/television.png'
import icon_movies from '../../NavBar/images/tv (1).png'
import icon_movies_active from '../../NavBar/images/tv.png'
import { useRouter } from "../../../hooks/router";
import { translateWord } from "../../Util/util";

export default function FilterButtons({ callBackFilterType, setTypeSearch }) {

    const router = useRouter()

    const [arrayBtns, setArrayBtns] = useState([
        { id: 0, name: 'All', type: 'all', icon: icon_btn_all, active_icon: icon_btn_all_active, active: true },
        {
            id: 1,
            name: 'Live TVs',
            type: 'live_tv',
            icon: icon_movies,
            active_icon: icon_movies_active,
            active: false
        },
        {
            id: 2,
            name: 'Movies',
            type: 'movie',
            icon: icon_tv_shows,
            active_icon: icon_tv_shows_active,
            active: false
        },
        {
            id: 3,
            name: 'TV Shows',
            type: 'tv-shows',
            icon: Icon_live_tv,
            active_icon: Icon_live_tv_active,
            active: false
        },
    ])

    useEffect(() => {
        
        if (router.query.type) {
            const x = arrayBtns.find(e => e.type === router.query.type)
            setTypeSearch(router.query.type)
            btn_filter(x)
        }

    }, [router.query.type])


    const btn_filter = (e) => {
        let newArray = arrayBtns
        let prevActive = newArray.find(k => k.active === true)
        prevActive.active = false
        e.active = true
        setArrayBtns(newArray)
        callBackFilterType(e.type)
    }

    return (
        <div className="filter_buttons_main">
            {arrayBtns.map((e, i) => {
                return (
                    <div key={i} onClick={() => btn_filter(e)} className="btn_filter_search"
                        style={{ backgroundColor: e.active ? '#38334C' : null }}>
                        <img src={e.active ? e.active_icon : e.icon} alt="" />
                        <p style={{ color: e.active ? 'white' : '#5E5E5E' }}>{translateWord(e.name)}</p>
                    </div>
                )
            })}
        </div>
    )
}